import React from "react";
import FixOpenQuantities from "./FixOpenQuantities";

const fixOpenQuantities = {
  path: "fix-open-quantities",
  sideNav: {
    group: 4,
    order: 71,
    label: "Audit Open Quantities",
    entityType: ["systemAdmin"],
    allowedRole: ["systemAdmin"],
    auth: ["authenticated"],
  },
  route: {
    index: {
      element: <FixOpenQuantities />,
      allowedRole: "all",
      entityType: "all",
      auth: ["authenticated"],
    },
  },
};

export default fixOpenQuantities;
